import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { LossType } from "@api/operations.generated";
import { ClaimSummaryBox } from "@routing/routes/ClaimSummary/types";
import { SummaryStepHistory } from "@routing/paths";
import { mapLossType } from "@utils/mapLossType";

export interface LossLocationDetails {
  lossAddress: string;
  lotUnit: string;
  lossType: LossType;
}

const initialState: LossLocationDetails = {
  lossAddress: "",
  lotUnit: "",
  lossType: undefined,
};

const lossDetailsSlice = createSlice({
  name: "lossDetails",
  initialState,
  selectors: {
    selectLossType: (state) => state.lossType,
    selectLossDetails: (state) => state,
    selectLossLocationDetailsSummary: ({
      lossAddress,
      lotUnit,
      lossType,
    }): ClaimSummaryBox => ({
      boxTitle: "Loss Location & Details",
      navigate: SummaryStepHistory.LOSS_LOCATION_DETAILS,
      items: [
        {
          value: lossAddress,
          label: "Property Address",
          fullWidth: !lotUnit,
        },
        {
          value: lotUnit,
          label: "Unit / Lot#",
          fullWidth: false,
        },
        {
          value: mapLossType(lossType),
          label: "What kind of loss occurred?",
          fullWidth: true,
        },
      ].filter((el) => el.value),
    }),
  },
  reducers: {
    setLossDetails: (_, { payload }: PayloadAction<LossLocationDetails>) =>
      payload,
    resetLossDetails: () => initialState,
  },
});

export const {
  actions: { setLossDetails, resetLossDetails },
  selectors: {
    selectLossDetails,
    selectLossType,
    selectLossLocationDetailsSummary,
  },
} = lossDetailsSlice;
export { initialState as lossDetailsInitialState };
export default lossDetailsSlice;
